/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * <p>Java class for parameterCapabilitiesType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="parameterCapabilitiesType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;all&gt; &lt;element name="optional" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="multivalued" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="discreteValue" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="boundRange" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="unboundedRange" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;/all&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ParameterCapabilitiesType extends MoserObject{

	optional = null;

	multivalued = null;

	discreteValue = null;

	boundRange = null;

	unboundedRange = null;



	/**
	 * Gets the value of the optional property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isOptional() {
		return this.optional;
	}

	/**
	 * Sets the value of the optional property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setOptional(value) {
		var oldValue = this.optional;
		this.optional = value;
		this._setAndNotify(255, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the multivalued property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isMultivalued() {
		return this.multivalued;
	}

	/**
	 * Sets the value of the multivalued property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setMultivalued(value) {
		var oldValue = this.multivalued;
		this.multivalued = value;
		this._setAndNotify(256, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the discreteValue property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isDiscreteValue() {
		return this.discreteValue;
	}

	/**
	 * Sets the value of the discreteValue property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setDiscreteValue(value) {
		var oldValue = this.discreteValue;
		this.discreteValue = value;
		this._setAndNotify(257, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the boundRange property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isBoundRange() {
		return this.boundRange;
	}

	/**
	 * Sets the value of the boundRange property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setBoundRange(value) {
		var oldValue = this.boundRange;
		this.boundRange = value;
		this._setAndNotify(258, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the unboundedRange property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isUnboundedRange() {
		return this.unboundedRange;
	}

	/**
	 * Sets the value of the unboundedRange property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setUnboundedRange(value) {
		var oldValue = this.unboundedRange;
		this.unboundedRange = value;
		this._setAndNotify(259, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>ParameterCapabilitiesType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ParameterCapabilitiesType</code> object from.
	 * @return {ParameterCapabilitiesType} an object of type <code>ParameterCapabilitiesType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createParameterCapabilitiesType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ParameterCapabilitiesType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 255, "optional", null));
		featureList.push(this.createFeature(false, false, false, 256, "multivalued", null));
		featureList.push(this.createFeature(false, false, false, 257, "discreteValue", null));
		featureList.push(this.createFeature(false, false, false, 258, "boundRange", null));
		featureList.push(this.createFeature(false, false, false, 259, "unboundedRange", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 255:
			this.setOptional((value));
			break;
		case 256:
			this.setMultivalued((value));
			break;
		case 257:
			this.setDiscreteValue((value));
			break;
		case 258:
			this.setBoundRange((value));
			break;
		case 259:
			this.setUnboundedRange((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 255:
			return this.isOptional();
		case 256:
			return this.isMultivalued();
		case 257:
			return this.isDiscreteValue();
		case 258:
			return this.isBoundRange();
		case 259:
			return this.isUnboundedRange();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 255:
			return this.isOptional();
		case 256:
			return this.isMultivalued();
		case 257:
			return this.isDiscreteValue();
		case 258:
			return this.isBoundRange();
		case 259:
			return this.isUnboundedRange();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ParameterCapabilitiesType.js